import React, { useState, useEffect, useMemo } from 'react';
import _, { debounce } from 'lodash';

import { PartnerCompanyBranchDropdown } from './PartnerCompanyBranchDropdown';
import Tippy, { ToolTip } from './ReactTippy';

import { UserAgencyService } from '../services/UserAgency';

export default function AgencyCompanyAgentManager(props) {
  const { company, selected_partner_company_id } = props.dialog.state;

  const [registableParams, setRegistableParams] = useState({
    partner_company_id: company.id,
    name: '',
    partner_company_branch_id: null,
  });
  const [agencyParams, setAgencyParams] = useState({
    partner_company_id: company.id,
    name: '',
    partner_company_branch_id: null,
  });
  const [registableUsersList, setRegistableUsersList] = useState([]);
  const [isLoadingRegistableUsers, setIsLoadingRegistableUsers] = useState(
    true
  );
  const [agencyUsersList, setAgencyUsersList] = useState([]);
  const [isLoadingAgencyUsers, setIsLoadingAgencyUsers] = useState(true);
  const [registableSelectedList, setRegistableSelectedList] = useState([]);
  const [agencySelectedList, setAgencySelectedList] = useState([]);
  const [movedRegistableList, setMovedRegistableList] = useState([]);
  const [movedAgencyList, setMovedAgencyList] = useState([]);
  const [selectedRegistableBranch, setSelectedRegistableBranch] = useState('');
  const [selectedAgencyBranch, setSelectedAgencyBranch] = useState('');

  // 未設定検索条件が変更した場合再取得する
  useEffect(
    () => {
      UserAgencyService.registableAgencyUsersList(registableParams)
        .then(response => {
          if (response.result) {
            setRegistableUsersList(
              _.orderBy(
                _.concat(
                  _.reject(
                    response.data.entities.registable_agency_users_list,
                    user => {
                      return _.find(movedRegistableList, user);
                    }
                  ),
                  movedAgencyList
                ),
                'id',
                'desc'
              )
            );
            setIsLoadingRegistableUsers(false);
          }
        })
        .catch(error => console.log(error));
    },
    [registableParams]
  );

  // 設定済み検索条件が変更した場合再取得する
  useEffect(
    () => {
      UserAgencyService.agencyUsersList(agencyParams)
        .then(response => {
          if (response.result) {
            setAgencyUsersList(
              _.orderBy(
                _.concat(
                  _.reject(response.data.entities.agency_users_list, user => {
                    return _.find(movedAgencyList, user);
                  }),
                  movedRegistableList
                ),
                'id',
                'desc'
              )
            );
            setIsLoadingAgencyUsers(false);
          }
        })
        .catch(error => console.log(error));
    },
    [agencyParams]
  );

  // 代行担当者未設定一覧 検索条件
  const setTempRegistableParamsBranch = params => {
    setSelectedRegistableBranch(params.partner_company_branch_id);
    const newParams = {
      ...params,
      partner_company_branch_id:
        params.partner_company_branch_id === ''
          ? null
          : params.partner_company_branch_id === '本社'
          ? ''
          : params.partner_company_branch_id,
    };
    setIsLoadingRegistableUsers(true);
    setRegistableParams(newParams);
  };

  const setTempRegistableParamsName = params => {
    setIsLoadingRegistableUsers(true);
    setRegistableParams(params);
  };

  const debounceRegistableParams = useMemo(
    () => debounce(setTempRegistableParamsName, 500),
    [props, registableParams]
  );

  // 代行担当者設定済み一覧 検索条件
  const setTempAgencyParamsBranch = params => {
    setSelectedAgencyBranch(params.partner_company_branch_id);
    const newParams = {
      ...params,
      partner_company_branch_id:
        params.partner_company_branch_id === ''
          ? null
          : params.partner_company_branch_id === '本社'
          ? ''
          : params.partner_company_branch_id,
    };
    setIsLoadingAgencyUsers(true);
    setAgencyParams(newParams);
  };

  const setTempAgencyParamsName = params => {
    setIsLoadingAgencyUsers(true);
    setAgencyParams(params);
  };

  const debounceAgencyParams = useMemo(
    () => debounce(setTempAgencyParamsName, 500),
    [props, agencyParams]
  );

  const toggleRegistableUser = user => {
    if (
      _.find(registableSelectedList, listUser => {
        return listUser.id === user.id;
      })
    ) {
      const updatedList = _.filter(registableSelectedList, item => {
        return item.id !== user.id;
      });
      setRegistableSelectedList(_.uniq(updatedList));
    } else {
      setRegistableSelectedList(_.uniq(registableSelectedList.concat(user)));
    }
  };

  const toggleRegistableUserRow = (event, user) => {
    if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'I') {
      toggleRegistableUser(user);
    }
  };

  const toggleRegistableUserCheckbox = user => {
    toggleRegistableUser(user);
  };

  const toggleAgencyUser = user => {
    if (
      _.find(agencySelectedList, listUser => {
        return listUser.id === user.id;
      })
    ) {
      const updatedList = _.filter(agencySelectedList, item => {
        return item.id !== user.id;
      });
      setAgencySelectedList(_.uniq(updatedList));
    } else {
      setAgencySelectedList(_.uniq(agencySelectedList.concat(user)));
    }
  };

  const toggleAgencyUserRow = (event, user) => {
    if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'I') {
      toggleAgencyUser(user);
    }
  };

  const toggleAgencyUserCheckbox = user => {
    toggleAgencyUser(user);
  };

  // 代行担当者未設定ユーザーを移動する
  const moveRegistableUsers = () => {
    const filteredSelectedList = _.reject(registableSelectedList, user => {
      return _.find(movedAgencyList, user);
    });
    setRegistableSelectedList(filteredSelectedList);
    setMovedAgencyList(
      _.reject(movedAgencyList, user => {
        return _.find(registableSelectedList, user);
      })
    );
    setMovedRegistableList(
      _.uniq(_.concat(movedRegistableList, filteredSelectedList))
    );
    const newAgencyUsersList = _.orderBy(
      _.uniq(_.concat(agencyUsersList, registableSelectedList)),
      'id',
      'desc'
    );

    setAgencyUsersList(newAgencyUsersList);

    const newRegistableUsersList = _.reject(registableUsersList, user => {
      // 元々未設定だったユーザーは設定済一覧から移動する必要ないため削除する
      return _.find(registableSelectedList, user);
    });

    setRegistableUsersList(newRegistableUsersList);
    setRegistableSelectedList([]);
  };

  // 代行担当者設定済ユーザーを移動する
  const moveAgencyUsers = () => {
    const filteredSelectedList = _.reject(agencySelectedList, user => {
      return _.find(movedRegistableList, user);
    });
    setAgencySelectedList(filteredSelectedList);
    setMovedRegistableList(
      _.reject(movedRegistableList, user => {
        return _.find(agencySelectedList, user);
      })
    );
    setMovedAgencyList(_.uniq(_.concat(movedAgencyList, filteredSelectedList)));
    const newRegistableUsersList = _.orderBy(
      _.uniq(_.concat(registableUsersList, agencySelectedList)),
      'id',
      'desc'
    );

    setRegistableUsersList(newRegistableUsersList);

    const newAgencyUsersList = _.reject(agencyUsersList, user => {
      // 元々設定済だったユーザーは未設定一覧から移動する必要ないため削除する
      return _.find(agencySelectedList, user);
    });
    setAgencyUsersList(newAgencyUsersList);
    setAgencySelectedList([]);
  };

  // 未設定ユーザーが移動された場合、代行担当者追加APIを実行する
  const addAgencyUsers = async () => {
    if (movedRegistableList.length === 0) {
      return;
    } else {
      const addingUsers = _.map(movedRegistableList, user => {
        return user.id;
      });
      const addParams = {
        registable_company_id: company.id,
        user_ids: addingUsers,
      };
      const response = await UserAgencyService.addAgencyUsers(addParams);
      return response;
    }
  };

  // 設定済ユーザーが移動された場合、代行担当者削除APIを実行する
  const revokeAgencyUsers = async () => {
    if (movedAgencyList.length === 0) {
      return;
    } else {
      const revokedUsers = _.map(movedAgencyList, user => {
        return user.id;
      });
      const revokeParams = {
        registable_company_id: company.id,
        user_ids: revokedUsers,
      };
      const response = await UserAgencyService.revokeAgencyUsers(revokeParams);
      return response;
    }
  };

  const submit = async () => {
    await Promise.all([addAgencyUsers(), revokeAgencyUsers()])
      .then(responses => {
        debounceRegistableParams.cancel();
        debounceAgencyParams.cancel();
        props.dialog.callback.success(responses);
        _.each(responses, (response, index) => {
          if (response && response.data.result === false) {
            if (index === 0) {
              // 未設定→追加エラーの場合、代行担当者未設定一覧に戻す
              setRegistableSelectedList(movedRegistableList);
              setRegistableUsersList(
                _.orderBy(
                  registableUsersList.concat(movedRegistableList),
                  'id',
                  'desc'
                )
              );
              setAgencyUsersList(
                _.orderBy(
                  agencyUsersList.filter(agencyUser => {
                    return !movedRegistableList.find(registableUser => {
                      return agencyUser.id === registableUser.id;
                    });
                  }),
                  'id',
                  'desc'
                )
              );
            }
            if (index === 1) {
              // 設定済み→削除エラーの場合、代行担当者設定済み一覧に戻す
              setAgencySelectedList(movedAgencyList);
              setAgencyUsersList(
                _.orderBy(agencyUsersList.concat(movedAgencyList), 'id', 'desc')
              );
              setRegistableUsersList(
                _.orderBy(
                  registableUsersList.filter(registableUser => {
                    return !movedAgencyList.find(agencyUser => {
                      return registableUser.id === agencyUser.id;
                    });
                  }),
                  'id',
                  'desc'
                )
              );
            }
          }
        });
      })
      .then(() => {
        setMovedRegistableList([]);
        setMovedAgencyList([]);
        // 代行担当者未設定一覧、代行担当者設定済み一覧を再読み込みする
        const cloneRegistableParams = _.cloneDeep(registableParams);
        const cloneAgencyParams = _.cloneDeep(agencyParams);
        setRegistableParams(cloneRegistableParams);
        setAgencyParams(cloneAgencyParams);
      });
  };

  return (
    <div className='dialog dialog-md dialog--modal AgencyCompanyAgentManager'>
      <div className='dialog-md__header'>
        <span className='dialog__title'>{company.name} 代行担当者</span>
      </div>
      <div className='dialog__body'>
        <div className='dual-panel'>
          {company.is_agency && (
            <React.Fragment>
              <div className='dual-panel__item'>
                <div className='panel'>
                  <div className='panel-header'>
                    <div className='panel-title'>代行担当者未設定</div>
                    {getSearchForm(
                      selected_partner_company_id,
                      registableParams,
                      setTempRegistableParamsBranch,
                      debounceRegistableParams,
                      selectedRegistableBranch
                    )}
                    <div className='table-wrapper'>
                      <div className='panel-list AgencyCompanyAgentManager__table'>
                        <table className='table table--worker-manage-label unassigned-table'>
                          <thead className='table__header'>
                            <tr className='table__label'>
                              <th className='value-table AgencyCompanyAgentManager__checkbox' />
                              <th className='value-table value-table_branch value-table--table__label'>
                                <span className='value-table__label'>支店</span>
                              </th>
                              <th className='value-table value-table--table__label'>
                                <span className='value-table__label'>氏名</span>
                              </th>
                              <th className='value-table value-table--table__label'>
                                <span className='value-table__label'>ID</span>
                              </th>
                            </tr>
                          </thead>
                          {isLoadingRegistableUsers ? (
                            <tbody className='table__body'>
                              <tr>
                                <td className='indicator' colSpan={4} />
                              </tr>
                            </tbody>
                          ) : (
                            <tbody className='table__body'>
                              {!_.size(registableUsersList) ? (
                                <tr>
                                  <td
                                    className='AgencyCompanyAgentManager__not-found'
                                    colSpan='4'
                                  >
                                    代行担当者に設定できるユーザーがいません。
                                  </td>
                                </tr>
                              ) : (
                                _.map(registableUsersList, user => {
                                  return (
                                    <tr
                                      className={
                                        // 移動予定の項目は色違い
                                        user.agency_updated_at
                                          ? 'table__item table__item--pending'
                                          : 'table__item'
                                      }
                                      key={user.id}
                                      onClick={e => {
                                        toggleRegistableUserRow(e, user);
                                      }}
                                    >
                                      <td className='value-table'>
                                        <div className='value-table__icon'>
                                          <div className='btn-checkbox-mini'>
                                            <label
                                              className='checkbox'
                                              htmlFor={`checkbox-${user.id}`}
                                            >
                                              <input
                                                id={`checkbox-${user.id}`}
                                                type='checkbox'
                                                name={user.id}
                                                checked={_.some(
                                                  registableSelectedList,
                                                  item => {
                                                    return item.id === user.id;
                                                  }
                                                )}
                                                onChange={() => {
                                                  toggleRegistableUserCheckbox(
                                                    user
                                                  );
                                                }}
                                              />
                                              <i className='i-square i-2x' />
                                            </label>
                                          </div>
                                        </div>
                                      </td>
                                      <td className='value-table'>
                                        <Tippy
                                          delay={[500, 0]}
                                          duration={10}
                                          arrow={true}
                                          arrowType='sharp'
                                          placement='bottom'
                                          html={
                                            <ToolTip>
                                              {user.partner_company_branch !==
                                              null
                                                ? user.partner_company_branch
                                                    .name
                                                : '本社'}
                                            </ToolTip>
                                          }
                                        >
                                          <div className='value-table__name'>
                                            {user.partner_company_branch !==
                                            null
                                              ? user.partner_company_branch.name
                                              : '本社'}
                                          </div>
                                        </Tippy>
                                      </td>
                                      <td className='value-table'>
                                        <Tippy
                                          delay={[500, 0]}
                                          duration={10}
                                          arrow={true}
                                          arrowType='sharp'
                                          placement='bottom'
                                          html={
                                            <ToolTip>{user.fullname}</ToolTip>
                                          }
                                        >
                                          <div className='value-table__name'>
                                            {user.fullname}
                                          </div>
                                        </Tippy>
                                      </td>
                                      <td className='value-table'>
                                        <Tippy
                                          delay={[500, 0]}
                                          duration={10}
                                          arrow={true}
                                          arrowType='sharp'
                                          placement='bottom'
                                          html={<ToolTip>{user.email}</ToolTip>}
                                        >
                                          <div className='value-table__name'>
                                            {user.email}
                                          </div>
                                        </Tippy>
                                      </td>
                                    </tr>
                                  );
                                })
                              )}
                            </tbody>
                          )}
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className='dual-panel__navi dual-panel__navi__worker'>
                <div className='dual-panel__navi-item'>
                  <button
                    className='btn-move__right'
                    onClick={() => {
                      moveRegistableUsers();
                    }}
                  />
                </div>
                <div className='dual-panel__navi-spacer' />
                <div className='dual-panel__navi-item'>
                  <button
                    className='btn-move__left'
                    onClick={() => {
                      moveAgencyUsers();
                    }}
                  />
                </div>
              </div>
            </React.Fragment>
          )}
          <div className='dual-panel__item'>
            <div className='panel'>
              <div className='panel-header'>
                <div className='panel-title'>代行担当者に設定済み</div>
                {getSearchForm(
                  selected_partner_company_id,
                  agencyParams,
                  setTempAgencyParamsBranch,
                  debounceAgencyParams,
                  selectedAgencyBranch,
                  company.is_agency
                )}
                <div className='table-wrapper'>
                  <div className='panel-list AgencyCompanyAgentManager__table'>
                    <table className='table table--worker-manage-label unassigned-table'>
                      <thead className='table__header'>
                        <tr className='table__label'>
                          {company.is_agency && (
                            <th className='value-table AgencyCompanyAgentManager__checkbox' />
                          )}
                          <th
                            className={
                              company.is_agency
                                ? 'value-table value-table_branch value-table--table__label'
                                : 'value-table value-table_branch value-table--table__label value-table--first'
                            }
                          >
                            <span className='value-table__label'>支店</span>
                          </th>
                          <th className='value-table value-table--table__label'>
                            <span className='value-table__label'>氏名</span>
                          </th>
                          <th className='value-table value-table--table__label'>
                            <span className='value-table__label'>ID</span>
                          </th>
                        </tr>
                      </thead>
                      {isLoadingAgencyUsers ? (
                        <tbody className='table__body'>
                          <tr>
                            <td className='indicator' colSpan={4} />
                          </tr>
                        </tbody>
                      ) : (
                        <tbody className='table__body'>
                          {!_.size(agencyUsersList) ? (
                            <tr>
                              <td
                                className='AgencyCompanyAgentManager__not-found'
                                colSpan='4'
                              >
                                代行担当者に設定済みのユーザーがいません。
                              </td>
                            </tr>
                          ) : (
                            _.map(agencyUsersList, user => {
                              return (
                                <tr
                                  className={
                                    // 移動予定の項目は色違い
                                    user.updated_at
                                      ? 'table__item table__item--pending'
                                      : 'table__item'
                                  }
                                  key={user.id}
                                  onClick={e => {
                                    if (company.is_agency) {
                                      toggleAgencyUserRow(e, user);
                                    }
                                  }}
                                >
                                  {company.is_agency && (
                                    <td className='value-table'>
                                      <div className='value-table__icon'>
                                        <div className='btn-checkbox-mini'>
                                          <label
                                            className='checkbox'
                                            htmlFor={`checkbox-${user.id}`}
                                          >
                                            <input
                                              id={`checkbox-${user.id}`}
                                              type='checkbox'
                                              name={user.id}
                                              checked={_.some(
                                                agencySelectedList,
                                                item => {
                                                  return item.id === user.id;
                                                }
                                              )}
                                              onChange={() => {
                                                if (company.is_agency) {
                                                  toggleAgencyUserCheckbox(
                                                    user
                                                  );
                                                }
                                              }}
                                            />
                                            <i className='i-square i-2x' />
                                          </label>
                                        </div>
                                      </div>
                                    </td>
                                  )}
                                  <td
                                    className={
                                      company.is_agency
                                        ? 'value-table'
                                        : 'value-table value-table--first'
                                    }
                                  >
                                    <Tippy
                                      delay={[500, 0]}
                                      duration={10}
                                      arrow={true}
                                      arrowType='sharp'
                                      placement='bottom'
                                      html={
                                        <ToolTip>
                                          {user.partner_company_branch !== null
                                            ? user.partner_company_branch.name
                                            : '本社'}
                                        </ToolTip>
                                      }
                                    >
                                      <div className='value-table__name'>
                                        {user.partner_company_branch !== null
                                          ? user.partner_company_branch.name
                                          : '本社'}
                                      </div>
                                    </Tippy>
                                  </td>
                                  <td className='value-table'>
                                    <Tippy
                                      delay={[500, 0]}
                                      duration={10}
                                      arrow={true}
                                      arrowType='sharp'
                                      placement='bottom'
                                      html={<ToolTip>{user.fullname}</ToolTip>}
                                    >
                                      <div className='value-table__name'>
                                        {user.fullname}
                                      </div>
                                    </Tippy>
                                  </td>
                                  <td className='value-table'>
                                    <Tippy
                                      delay={[500, 0]}
                                      duration={10}
                                      arrow={true}
                                      arrowType='sharp'
                                      placement='bottom'
                                      html={<ToolTip>{user.email}</ToolTip>}
                                    >
                                      <div className='value-table__name'>
                                        {user.email}
                                      </div>
                                    </Tippy>
                                  </td>
                                </tr>
                              );
                            })
                          )}
                        </tbody>
                      )}
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='dialog-md__footer-horizontal'>
        <button
          className='btn-fixedsize--sub'
          onClick={() => {
            debounceRegistableParams.cancel();
            debounceAgencyParams.cancel();
            props.dialog.callback.close();
          }}
        >
          戻る
        </button>
        {company.is_agency && (
          <button
            className='btn-fixedsize--effective'
            onClick={() => {
              submit();
            }}
          >
            追加
          </button>
        )}
      </div>
    </div>
  );
}

/**
 * 絞り込みフォーム
 * @param {int} total
 * @param tableKind
 */
const getSearchForm = (
  selected_partner_company_id,
  params,
  setParamsBranch,
  setParamsName,
  selectedCompanyBranch,
  is_agency = true
) => {
  return (
    <div className='master-slide-view__searchform'>
      <div className='search-form'>
        <div id='search-form-accordion' className='accordion show'>
          <div className='search-form__body'>
            <div className='form form--search-form'>
              <div className='form__group'>
                <div className='AgencyCompanyAgentManager__search'>
                  <div className='AgencyCompanyAgentManager__label'>
                    <span className='label'>支店で検索</span>
                  </div>
                  <div className='AgencyCompanyAgentManager__dropdown'>
                    <PartnerCompanyBranchDropdown
                      selectedCompanyId={selected_partner_company_id}
                      selectedPartnerCompanyBranchId={selectedCompanyBranch}
                      onSelect={id => {
                        setParamsBranch({
                          ...params,
                          partner_company_branch_id: id,
                        });
                      }}
                      fixedOptions={[{ id: '本社', name: '本社' }]}
                      isOptional={true}
                      dropdownSelectStyle={{ width: 'initial' }}
                    />
                  </div>
                </div>
                <div className='AgencyCompanyAgentManager__search'>
                  <div className='AgencyCompanyAgentManager__label'>
                    <span className='label label--name'>氏名で検索</span>
                  </div>
                  <div className='AgencyCompanyAgentManager__dropdown'>
                    <input
                      className='AgencyCompanyAgentManager__input'
                      type='text'
                      name='name'
                      placeholder='ユーザー名'
                      defaultValue={params.name}
                      onChange={event =>
                        setParamsName({
                          ...params,
                          name: event.target.value,
                        })
                      }
                    />
                  </div>
                </div>
              </div>
              <div className='AgencyCompanyAgentManager__search-info'>
                {is_agency ? (
                  <div className='AgencyCompanyAgentManager__search-info-text'>
                    ※検索条件で支店を選択してユーザーが見つからない場合、支店を未選択にし氏名のみで再度検索してください。
                  </div>
                ) : (
                  <div className='AgencyCompanyAgentManager__search-info-text'>
                    ※検索条件で支店を選択してユーザーが見つからない場合、支店を未選択にし氏名のみで再度検索してください。
                    <br />
                    ※代行担当者の追加・削除は、すでに代行担当者として設定済みのユーザーのみ行えます。代行担当者にご依頼ください。
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/AgencyCompanyAgentManager.jsx